import React from "react";
import { Col, Row } from "antd";

import CaseBreakdown from "./cases-breakdown/CaseBreakdown";
import AgeAssessmentBarChart from "./bar-chart/AgeAssessmentBarChart";

const CaseGraphAndProgressBar = ({ data }) => {
  const monthlyCases = data?.monthly_cases_chart || [];

  return (
    <div>
      <Row gutter={[20, 20]}>
        <Col md={12} sm={24} xs={24}>
          <AgeAssessmentBarChart data={monthlyCases} />
        </Col>

        <Col md={12}>
          <CaseBreakdown data={data} />
        </Col>
      </Row>
    </div>
  );
};

export default CaseGraphAndProgressBar;
